import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { X } from "lucide-react";
import { useTranslation } from "react-i18next";

// Renders the standalone journey experience inside an iframe so the browser
// address bar never leaves the root domain. All internal navigation is
// masked by the app's MemoryRouter.
export default function Journey() {
  const { t } = useTranslation();
  const nav = useNavigate();

  useEffect(() => {
    // hide the site navbar/footer by adding a body class — cleanup on unmount
    document.body.classList.add("journey-fullscreen");
    return () => document.body.classList.remove("journey-fullscreen");
  }, []);

  return (
    <div
      data-testid="journey-page"
      style={{
        position: "fixed",
        inset: 0,
        background: "#000",
        zIndex: 60,
      }}
    >
      <iframe
        title="HepCURE interactive journey"
        src="/journey.html"
        style={{ width: "100%", height: "100%", border: 0 }}
        allow="autoplay; fullscreen"
      />

      <button
        type="button"
        onClick={() => nav("/")}
        aria-label={t("journey.closeAria")}
        data-testid="journey-close"
        style={{
          position: "absolute",
          top: 16,
          right: 16,
          zIndex: 5,
          width: 40,
          height: 40,
          borderRadius: 999,
          background: "rgba(0,0,0,.55)",
          color: "#fff",
          border: "1px solid rgba(255,255,255,.35)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
        }}
      >
        <X size={20} />
      </button>
    </div>
  );
}
